import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom'
import { useEffect, lazy, Suspense } from 'react'
import Header from './components/Header'
import Footer from './components/Footer'
import CookieConsent from './components/CookieConsent'
import { ToastProvider } from './components/Toast'

// Lazy Load Pages
const Home = lazy(() => import('./pages/Home'))
const Services = lazy(() => import('./pages/Services'))
const ManagedServices = lazy(() => import('./pages/ManagedServices'))
const Partners = lazy(() => import('./pages/Partners'))
const CareerForm = lazy(() => import('./pages/Career-Form'))
const Contact = lazy(() => import('./pages/Contact'))
const NotFound = lazy(() => import('./pages/NotFound'))
const PrivacyPolicy = lazy(() => import('./pages/PrivacyPolicy'))
const CookiePolicy = lazy(() => import('./pages/CookiePolicy'))
const TermsConditions = lazy(() => import('./pages/TermsConditions'))
const Sitemap = lazy(() => import('./pages/Sitemap'))
const ServiceDetail = lazy(() => import('./pages/ServiceDetail'))

// Lazy Load External Solutions
const CloudSolutions = lazy(() => import('./pages/external-links/CloudSolutions'))
const CyberSecurity = lazy(() => import('./pages/external-links/CyberSecurity'))
const DataCenter = lazy(() => import('./pages/external-links/DataCenter'))
const EndUserSupport = lazy(() => import('./pages/external-links/EndUserSupport'))
const HighSpeedFiber = lazy(() => import('./pages/external-links/HighSpeedFiber'))
const LANSolutions = lazy(() => import('./pages/external-links/LANSolutions'))
const NetworkMonitoring = lazy(() => import('./pages/external-links/NetworkMonitoring'))
const VideoSurveillance = lazy(() => import('./pages/external-links/VideoSurveillance'))
const WANSolutions = lazy(() => import('./pages/external-links/WANSolutions'))

function ScrollToTop() {
  const { pathname } = useLocation()
  useEffect(() => { window.scrollTo(0, 0) }, [pathname])
  return null
}

function Layout({ children }) {
  const { pathname } = useLocation()
  const isHome = pathname === '/'
  const externalRoutes = [
    '/cloud-solutions',
    '/cyber-security',
    '/data-center',
    '/end-user-support',
    '/high-speed-fiber',
    '/lan-solutions',
    '/network-monitoring',
    '/video-surveillance',
    '/wan-solutions'
  ]
  const isExternal = externalRoutes.includes(pathname)
  
  return (
    <>
      <Header />
      <main style={{ paddingTop: (isHome || isExternal) ? 0 : '80px' }}>{children}</main>
      <Footer />
      <CookieConsent />
    </>
  )
}

// Loading Fallback
const PageLoader = () => (
  <div style={{ height: '100vh', width: '100%', background: '#fff' }} />
)

export default function App() {
  return (
    <ToastProvider>
      <BrowserRouter>
        <ScrollToTop />
        <Layout>
          <Suspense fallback={<PageLoader />}>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/services" element={<Services />} />
              <Route path="/service/:slug" element={<ServiceDetail />} />
              <Route path="/managed-services" element={<ManagedServices />} />
              <Route path="/managed-services/:slug" element={<ManagedServices />} />
              <Route path="/partners" element={<Partners />} />
              <Route path="/careers" element={<CareerForm />} />
              <Route path="/contact" element={<Contact />} />
              <Route path="/privacy-policy" element={<PrivacyPolicy />} />
              <Route path="/cookie-policy" element={<CookiePolicy />} />
              <Route path="/terms-conditions" element={<TermsConditions />} />
              <Route path="/sitemap" element={<Sitemap />} />
              
              {/* External Solutions Routes */}
              <Route path="/cloud-solutions" element={<CloudSolutions />} />
              <Route path="/cyber-security" element={<CyberSecurity />} />
              <Route path="/data-center" element={<DataCenter />} />
              <Route path="/end-user-support" element={<EndUserSupport />} />
              <Route path="/high-speed-fiber" element={<HighSpeedFiber />} />
              <Route path="/lan-solutions" element={<LANSolutions />} />
              <Route path="/network-monitoring" element={<NetworkMonitoring />} />
              <Route path="/video-surveillance" element={<VideoSurveillance />} />
              <Route path="/wan-solutions" element={<WANSolutions />} />

              <Route path="*" element={<NotFound />} />
            </Routes>
          </Suspense>
        </Layout>
      </BrowserRouter>
    </ToastProvider>
  )
}
